import { createApi } from '@reduxjs/toolkit/query/react';
import { getHeaders } from 'auth/auth';
import { baseQueryWithReauth } from '../baseQuery';

// PROD-138 + PROD-234 — Manulife appraisal integration.
// Backend routes live in app/api/v1/routes/b2b/loans/appraisals.py.
export const appraisalsAPI = createApi({
  reducerPath: 'appraisalsAPI',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Appraisal'],
  endpoints: (builder) => ({
    listAppraisals: builder.query({
      query: ({ applicationId }) => ({
        url: `/b2b/loans/applications/${applicationId}/appraisals`,
        method: 'GET',
        headers: getHeaders(),
      }),
      providesTags: (_result, _err, { applicationId }) => [
        { type: 'Appraisal', id: applicationId },
      ],
    }),

    getAppraisal: builder.query({
      query: ({ applicationId, appraisalId }) => ({
        url: `/b2b/loans/applications/${applicationId}/appraisals/${appraisalId}`,
        method: 'GET',
        headers: getHeaders(),
      }),
      providesTags: (_result, _err, { appraisalId }) => [
        { type: 'Appraisal', id: appraisalId },
      ],
    }),

    previewAppraisal: builder.mutation({
      // Calls the wrapper /metadata endpoint via the backend.
      // Response shape: { fields: MetadataField[], missing_required: string[] }
      query: ({ applicationId, data }) => ({
        url: `/b2b/loans/applications/${applicationId}/appraisals/preview`,
        method: 'POST',
        body: data,
        headers: getHeaders(),
      }),
    }),

    submitAppraisal: builder.mutation({
      query: ({ applicationId, data }) => ({
        url: `/b2b/loans/applications/${applicationId}/appraisals`,
        method: 'POST',
        body: data,
        headers: getHeaders(),
      }),
      invalidatesTags: (_result, _err, { applicationId }) => [
        { type: 'Appraisal', id: applicationId },
      ],
    }),

    updateAppraisalValue: builder.mutation({
      query: ({ applicationId, appraisalId, data }) => ({
        url: `/b2b/loans/applications/${applicationId}/appraisals/${appraisalId}/value`,
        method: 'PATCH',
        body: data,
        headers: getHeaders(),
      }),
      invalidatesTags: (_result, _err, { applicationId, appraisalId }) => [
        { type: 'Appraisal', id: applicationId },
        { type: 'Appraisal', id: appraisalId },
      ],
    }),
  }),
});

export const {
  useListAppraisalsQuery,
  useGetAppraisalQuery,
  usePreviewAppraisalMutation,
  useSubmitAppraisalMutation,
  useUpdateAppraisalValueMutation,
} = appraisalsAPI;
